export const BASE_ENDPOINT = process.env.REACT_APP_BASE_ENDPOINT;